import i18n from '../../i18n';

export const neConfig = {
  get labels() {
    return {
      part_ir: i18n.t('countryLabels.ne.partIr'),
      trimf: i18n.t('countryLabels.ne.trimf'),
    };
  },
  currency: "FCFA",
  taxSystem: "ne",
  // Le salaire de base est saisi librement, sans passer par convention/catégorie.
  flexibleBaseSalary: true,
  // Ordonnance 2025-35 : retenue FSSP sur l'indemnité de responsabilité.
  fsspResponsabilite: true,
  allowedReports: [
    "Livre de paie",
    "Charges salariales",
    "Charges patronales",
    "ITS Niger",
    "annuelle ITS",
    "FSSP Niger",
  ]
};
